import React, { useState } from "react";

import { ShareDialog } from "#app/components/sharing/share-dialog";
import { useIssueShareHeader } from "#app/lib/hooks/use-issue-share-header";
import { useItemSharing } from "#app/lib/hooks/use-item-sharing";

// Item-specific wrapper around the generic ShareDialog. Reuses the
// useItemSharing hook for share data + mutations and useIssueShareHeader
// for the issue's display name / icon — the dialog itself stays a thin
// component.

type ItemShareDialogProps = {
  issueId: string | null;
  onOpenChange: (open: boolean) => void;
};

export function ItemShareDialog({
  issueId,
  onOpenChange,
}: ItemShareDialogProps) {
  const [activeSearch, setActiveSearch] = useState<string | undefined>(
    undefined,
  );

  const header = useIssueShareHeader(issueId);
  const sharing = useItemSharing(issueId, activeSearch);

  // Issue type "name" maps to "Project"/"Account"/"Contact" — the
  // subheader phrasing uses the lower-cased form so it reads naturally.
  const issueTypeName = header.issueTypeName ?? "Project";

  return (
    <ShareDialog
      open={issueId != null}
      onOpenChange={onOpenChange}
      title={`Share this ${issueTypeName.toLowerCase()}`}
      subheaderText={`Sharing as a single ${issueTypeName.toLowerCase()} of`}
      subheaderIcon={header.icon}
      subheaderName={header.name ?? "—"}
      onSearchChange={setActiveSearch}
      {...sharing}
    />
  );
}
